import validation from './validation.js';

var formValidation = {

	/**
	 * Initializes the form validation process.
	 *
	 * It starts the process by first initializing the 'blur' event for the input elements within
	 * forms that require validation using the 'initBlurEvent' method of the 'formValidation' object.
	 * It then initializes the 'submit' event for forms that require validation using
	 * the 'initSubmitEvent' method of the 'formValidation' object.
	 *
	 * @function init
	 * @returns {void}
	 */
	init: function(target) {
		formValidation.initBlurEvent(target);
		formValidation.initSubmitEvent(target);
	},

	/**
	 * Initializes the 'blur' event for input elements within forms that require validation.
	 *
	 * It targets form elements that have a 'data-validate' attribute within the body element.
	 * It then specifies which input elements need to be validated, i.e., 'input[data-validate]',
	 * 'select[data-validate]', 'textarea[data-validate]'.
	 *
	 * For each input type within each form that needs to be validated, it attaches a 'blur' event listener.
	 * On triggering the 'blur' event, it checks if the event target is one of the specified inputs.
	 * If it's not, the event is ignored; if it is, the 'checkInput' method of the 'validation' object is called.
	 *
	 * @function initBlurEvent
	 * @returns {void}
	 */
	initBlurEvent: function(target) {

		var forms = target.querySelectorAll('body form[data-validate]');
		var inputs = ['input[data-validate]', 'select[data-validate]', 'textarea[data-validate]'];

		inputs.forEach(function(input) {
			forms.forEach(function(form) {
				form.addEventListener('blur', function(event) {
					if (!event.target.matches(input)) return;
					validation.checkInput(event.target);
				}, true);
			});
		});

	},

	/**
	 * Initializes the 'submit' event for each form that requires validation.
	 *
	 * The function first selects all form elements with a 'data-validate' attribute within the body.
	 * It then adds a 'submit' event listener to each of these forms.
	 *
	 * On the 'submit' event, it checks the 'data-validate-onsubmit-disabled' attribute of the event target.
	 * If this attribute value is not 'true', the 'submitFormOnEvent' method of the 'validation' object is called.
	 * If the returned value is false, it prevents the form from being submitted by using 'e.preventDefault()'.
	 *
	 * The event listener is set to capture events during the capturing phase (indicated by the 'true' parameter).
	 *
	 * @function initSubmitEvent
	 * @returns {void}
	 */
	initSubmitEvent: function(target) {
		var forms = target.querySelectorAll('body form[data-validate]');

		forms.forEach(function(form) {
			form.addEventListener('submit', async function(e) {
				e.preventDefault();

				var noSubmit = e.target.getAttribute('data-validate-onsubmit-disabled') || false;
				if (noSubmit !== 'true') {
					let validated = await validation.submitFormOnEvent(e);
					if (!validated) {
						return;
					}
					form.submit();
				}

			}, true);
		});
	}

};

export default formValidation;
